import { type ComponentPropsWithoutRef, type FC } from 'react'

type Props = ComponentPropsWithoutRef<'tbody'>

/**
 * 基本的なTbodyコンポーネント
 */
export const BasicTbody: FC<Props> = ({ children, ...props }) => {
  return <tbody {...props}>{children}</tbody>
}
